import Vue from 'vue';
import { ASTNode, print } from 'graphql';
import AccessDeniedError from '@/objects/errors/accessDenied';
import { SNACK_ACTION } from '@/store/snackbar';
import store from '@/store';
import InternetDownError from '@/objects/errors/internetDown';

export default async function graphql(query: ASTNode, variables: object | null, logOffOnAccessDenied = true, throwErrorOnInternetDown = false) {
  try {
    const response = await fetch(process.env.VUE_APP_API_URL, {
      method: 'POST',
      headers: { Authorization: `${Vue.$cookies.get('session_id')}` },
      body: JSON.stringify({ query: print(query), variables }),
    });

    const json = await response.json();

    if (response.status === 400 || response.status === 500) {
      if (json.errors && json.errors.length) {
        await store.dispatch(SNACK_ACTION.ERROR, `<b>There was an error, please refresh the page</b>: ${json.errors[0].message}`);

        console.error(json.errors[0]);
      }
      return null;
    }

    if (json.errors && json.errors[0].extensions && json.errors[0].extensions.exception) {
      if (json.errors[0].extensions.exception.accessDenied) {
        if (logOffOnAccessDenied) {
          await store.dispatch('self/logOff', true);
        } else {
          throw new AccessDeniedError();
        }
      }

      await store.dispatch(SNACK_ACTION.ERROR, `${json.errors[0].message}`);
      return null;
    }

    return json.data;
  } catch (err) {
    if (err instanceof AccessDeniedError) {
      throw new AccessDeniedError();
    }

    await store.dispatch(SNACK_ACTION.ERROR, `<b>There was an error, please check your internet connection</b>: ${err.message}`);

    if (throwErrorOnInternetDown) {
      throw new InternetDownError();
    }

    return undefined;
  }
}
